// import { AUTH_PREFIX_PATH } from "configs/AppConfig";
// import React from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse";
import { MESSAGE_TYPE } from "redux/constants/ApiMessageResponse";

const ProtectedRoute = ({ children, ...reset }) => {
  const { token } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const intl = useIntl();

  const location = useLocation();

  const isAuthenticated = () => {
    var result =
      token !== "" && token !== undefined && token !== null ? true : false;
    if (!result) {
      dispatch(
        apiResponseMessage({
          showMessage: true,
          message: intl.formatMessage({ id: "please-sign-in" }),
          messageType: MESSAGE_TYPE.ERROR,
        })
      );
    }
    return result;
  };
  return (
    <>
      {isAuthenticated() ? (
        children
      ) : (
        <Navigate to={`/login`} state={{ prevUrl: location.pathname }} />
      )}
    </>
  );
};

export default ProtectedRoute;
